import { CategoryChartQueryFn, CategoryChartQueryParam } from "../categoryChart";

import { HorizontalTwoLineLabelKpiProviders } from "./categoryChartData.types";
import { fetchHorizontalTwoLineProviders } from "./fetchHorizontalTwoLineComparisonChartData";

export const fetchHorizontalTwoLineProviderChartData: CategoryChartQueryFn = async (
    args: CategoryChartQueryParam
): Promise<HorizontalTwoLineLabelKpiProviders> => {
    return fetchHorizontalTwoLineProviders(args);
};
